export const calculateDiagonal = (width: number, height: number) =>
	Math.sqrt(width ** 2 + height ** 2);

export const calculateDiagonalAngle = (width: number, height: number) => {
	const diagonal = calculateDiagonal(width, height);
	const angle = Math.asin(height / diagonal) * (180 / Math.PI);

	return angle;
};
